/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { MemberClassificationDto } from './memberClassificationDto.schema';

export const IReadOnlyListOfMemberClassificationDto = zod.array(zod.lazy(() => MemberClassificationDto));

export type IReadOnlyListOfMemberClassificationDto = zod.input<typeof IReadOnlyListOfMemberClassificationDto>;
export type IReadOnlyListOfMemberClassificationDtoOutput = zod.output<typeof IReadOnlyListOfMemberClassificationDto>;
